import React, { useEffect, useState } from "react";
import { Link, Outlet, useNavigate } from "react-router-dom";
import ManagementListItem from "./ManagementListItem";
import ProductionListItem from "./ProductionListItem";
import WarehouseListItem from "./WarehouseListItem";
import { IoReorderThreeOutline } from "react-icons/io5";
import { HiHome } from "react-icons/hi";
import { IoMdNotificationsOutline } from "react-icons/io";
import { IoSettingsOutline } from "react-icons/io5";
import { FcCollapse } from "react-icons/fc";
import { FcExpand } from "react-icons/fc";
import { CgProfile } from "react-icons/cg";
import QuickSelect from "./QuickSelect";
import CompanyProfile from "../Company/CompanyProfile";
import UserProfile from "../User/UserProfile";
import { useSelector, useDispatch } from "react-redux";
import { setUserPermissions, setshowDropdown } from "../../redux/slices/user/userSlice";
import {getAuthorization} from "../../axios/AxiosAut";
import axios from "axios";
import Swal from "sweetalert2";
import companyLogo from '../../../assets/fabrik.png';

export default function MainLayout() {
  const UserPermissions = useSelector((state) => state.user.userPermissions);
  const showDropdown = useSelector((state) => state.user.showDropdown);
  const [showsidebar, setshowsidebar] = useState(true);
  const [collaps, setcollaps] = useState(false);
  const dispatch = useDispatch()
  const Navigate = useNavigate();

  const baseURL = "https://web-production-3590.up.railway.app/"
  const getToken=()=>{
    return localStorage.getItem('token')
  }

  const showdropdown = () => {
    dispatch(setshowDropdown(!showDropdown));
  };
  const DropdownItems = [
    {
      id: 1,
      Name: "User profile",
      Link: "/dashboard/user-profile",
      icon: <svg  className="mr-3 " width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M19.7274 20.4471C19.2716 19.1713 18.2672 18.0439 16.8701 17.2399C15.4729 16.4358 13.7611 16 12 16C10.2389 16 8.52706 16.4358 7.12991 17.2399C5.73276 18.0439 4.72839 19.1713 4.27259 20.4471" stroke="white" stroke-width="2" stroke-linecap="round"/>
      <circle cx="12" cy="8" r="4" stroke="white" stroke-width="2" stroke-linecap="round"/>
      </svg>
      ,
    },
    {
      id: 2,
      Name: "Copmany profile",
      Link:"",

      icon: <svg  className="mr-3 " width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="4" y="4" width="6" height="7" rx="1" stroke="white" stroke-width="2" stroke-linejoin="round"/>
      <rect x="4" y="15" width="6" height="5" rx="1" stroke="white" stroke-width="2" stroke-linejoin="round"/>
      <rect x="14" y="4" width="6" height="5" rx="1" stroke="white" stroke-width="2" stroke-linejoin="round"/>
      <rect x="14" y="13" width="6" height="7" rx="1" stroke="white" stroke-width="2" stroke-linejoin="round"/>
      </svg>
      ,
    },
    {
      id: 3,
      Name: "Switch company",
      Link:"",

      icon: <svg  className="mr-3 " width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M18 20L17.2929 20.7071L18 21.4142L18.7071 20.7071L18 20ZM13 4C12.4477 4 12 4.44771 12 5C12 5.55229 12.4477 6 13 6L13 4ZM13.2929 16.7071L17.2929 20.7071L18.7071 19.2929L14.7071 15.2929L13.2929 16.7071ZM18.7071 20.7071L22.7071 16.7071L21.2929 15.2929L17.2929 19.2929L18.7071 20.7071ZM19 20L19 9L17 9L17 20L19 20ZM14 4L13 4L13 6L14 6L14 4ZM19 9C19 6.23858 16.7614 4 14 4L14 6C15.6569 6 17 7.34315 17 9L19 9Z" fill="white"/>
      <path d="M6 4L6.70711 3.29289L6 2.58579L5.29289 3.29289L6 4ZM11 20C11.5523 20 12 19.5523 12 19C12 18.4477 11.5523 18 11 18L11 20ZM10.7071 7.29289L6.70711 3.29289L5.29289 4.70711L9.29289 8.70711L10.7071 7.29289ZM5.29289 3.29289L1.29289 7.29289L2.70711 8.70711L6.70711 4.70711L5.29289 3.29289ZM5 4L5 15L7 15L7 4L5 4ZM10 20L11 20L11 18L10 18L10 20ZM5 15C5 17.7614 7.23858 20 10 20L10 18C8.34315 18 7 16.6569 7 15L5 15Z" fill="white"/>
      </svg>
      ,
    },
    {
      id: 4,
      Name: "Notifications",
      Link:"",

      icon: <svg  className="mr-3 " width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M6.44784 7.96942C6.76219 5.14032 9.15349 3 12 3V3C14.8465 3 17.2378 5.14032 17.5522 7.96942L17.804 10.2356C17.8072 10.2645 17.8088 10.279 17.8104 10.2933C17.9394 11.4169 18.3051 12.5005 18.8836 13.4725C18.8909 13.4849 18.8984 13.4973 18.9133 13.5222L19.4914 14.4856C20.0159 15.3599 20.2782 15.797 20.2216 16.1559C20.1839 16.3946 20.061 16.6117 19.8757 16.7668C19.5971 17 19.0873 17 18.0678 17H5.93223C4.91268 17 4.40291 17 4.12434 16.7668C3.93897 16.6117 3.81609 16.3946 3.77841 16.1559C3.72179 15.797 3.98407 15.3599 4.50862 14.4856L5.08665 13.5222C5.10161 13.4973 5.10909 13.4849 5.11644 13.4725C5.69488 12.5005 6.06064 11.4169 6.18959 10.2933C6.19123 10.279 6.19283 10.2645 6.19604 10.2356L6.44784 7.96942Z" stroke="white" stroke-width="2"/>
      <path d="M9.10222 17.6647C9.27315 18.6215 9.64978 19.467 10.1737 20.0701C10.6976 20.6731 11.3396 21 12 21C12.6604 21 13.3024 20.6731 13.8263 20.0701C14.3502 19.467 14.7269 18.6215 14.8978 17.6647" stroke="white" stroke-width="2" stroke-linecap="round"/>
      </svg>
      ,
    },
    {
      id: 5,
      Name: "Settings",
      Link:"/dashboard/settings",

      icon: <svg  className="mr-3 " width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M3.08168 13.9445C2.55298 12.9941 2.28862 12.5188 2.28862 12C2.28862 11.4812 2.55298 11.0059 3.08169 10.0555L4.43094 7.63L5.85685 5.24876C6.4156 4.31567 6.69498 3.84912 7.14431 3.5897C7.59364 3.33028 8.13737 3.3216 9.22483 3.30426L12 3.26L14.7752 3.30426C15.8626 3.3216 16.4064 3.33028 16.8557 3.5897C17.305 3.84912 17.5844 4.31567 18.1431 5.24876L19.5691 7.63L20.9183 10.0555C21.447 11.0059 21.7114 11.4812 21.7114 12C21.7114 12.5188 21.447 12.9941 20.9183 13.9445L19.5691 16.37L18.1431 18.7512C17.5844 19.6843 17.305 20.1509 16.8557 20.4103C16.4064 20.6697 15.8626 20.6784 14.7752 20.6957L12 20.74L9.22483 20.6957C8.13737 20.6784 7.59364 20.6697 7.14431 20.4103C6.69498 20.1509 6.4156 19.6843 5.85685 18.7512L4.43094 16.37L3.08168 13.9445Z" stroke="white" stroke-width="2"/>
      <circle cx="12" cy="12" r="3" stroke="white" stroke-width="2"/>
      </svg>
      ,
    },
    {
      id: 6,
      Name: "Logout",
      Link:"",

      icon: <svg  className="mr-3 " width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="15" y="9" width="6" height="6" rx="2" transform="rotate(-90 15 9)" stroke="white" stroke-width="2"/>
      <path d="M6 21L3 17L6 13" stroke="white" stroke-width="2"/>
      <path d="M3 17H10C13.7712 17 15.6569 17 16.8284 15.8284C18 14.6569 18 12.7712 18 9V9" stroke="white" stroke-width="2"/>
      </svg>
      ,
    },
    
  ];
  const setPermissions = () => {
    console.log("Here")
    let data=[];
    getAuthorization()
      .get("/users/user_permissions/")
      .then((res) => {
        dispatch(setUserPermissions(res.data));
        // localStorage.setItem("Permissions",JSON.stringify(UserPermissions));
        // console.log("LocalStorage",JSON.parse(localStorage.getItem("Permissions")!))
        data=(res.data);
        console.log("data", data);
        console.log("UserPermissions", UserPermissions);
      })
      .catch((err) => {
        console.log("Error in getting user Permissions", err);
      });
  };
  console.log("UserPermissions", UserPermissions);

useEffect(() => {
  setPermissions();
}, [])

  const handleShow = () => {
    setshowsidebar(!showsidebar);
  };
  const handlecollaps = () => {
    setcollaps(!collaps);
  };

  const LogoutHandler=()=>{
    axios.post(`${baseURL}auth/revoke-token/`, {
      client_id: "IwXZxqdvz8puzBpu1hX5mNJlQY38hDNK8tzhu6KL",
      client_secret:
        "Bl83aJmhAK91vmdbPtfRF0xUVPQB2Y9rrwPzYePOgYm3qbX2Rs6GF8PV3GPOGbS1p5uVVKC9YAuysagrNsMSu2wNJWALxxTc8C0HKD4rOK4vX3ajhNNNOkP9R1hmn5Ku",
      token: `${getToken()}`
    }).then((res)=>{
      console.log("Logged Out Successfully")
    }).catch((err)=>{
      console.log("error", err)
    })
    Swal.fire({
      position: "top-end",
      title: "Logged Out",
      showConfirmButton: false,
      timer: 5500,
      showClass: {
        popup: "animate__animated animate__fadeInRight",
      },
      hideClass: {
        popup: "animate__animated animate__fadeOutRight",
      },
      width: 300,
      color: "#FFFFFF",
      background: "#2A91D7",
      backdrop: `rgba(0,0,0,0)`,
    });
    Navigate("/login")
    showdropdown()
  }
 
  return (
    <>
      <div className="flex min-h-screen">
        {showsidebar && (
          <div className="min-w-max bg-blue-200 border-r border-blue-200 rounded-r-lg">
            <Link
              to="/dashboard/company-profile"
              className="py-10 px-6 flex items-center"
            >
              {/* <svg
                width="39"
                height="45"
                viewBox="0 0 39 45"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M38.0938 26.3591C38.0938 31.2705 36.0899 35.9807 32.5231 39.4535C28.9562 42.9264 24.1185 44.8774 19.0742 44.8774C14.0299 44.8774 9.19224 42.9264 5.62538 39.4535C2.05853 35.9807 0.0546876 31.2705 0.0546875 26.3591C0.0546875 21.7124 2.09722 16.3578 6.12647 10.4446C6.24668 10.2682 6.40144 10.1165 6.58191 9.99838C6.76237 9.88024 6.965 9.79791 7.17818 9.7561C7.39137 9.7143 7.61093 9.71384 7.8243 9.75475C8.03766 9.79567 8.24065 9.87715 8.42163 9.99453L15.0942 14.3258L21.4719 1.28529C21.5857 1.05263 21.7551 0.849942 21.966 0.694265C22.1769 0.538588 22.4231 0.434465 22.6839 0.390643C22.9446 0.346821 23.2124 0.364581 23.4647 0.442431C23.717 0.52028 23.9464 0.655945 24.1336 0.838028C27.1817 3.80056 30.6621 7.39432 33.3652 11.5853C36.5468 16.5188 38.0936 21.3513 38.0936 26.3589L38.0938 26.3591Z"
                  fill="#00EDDF"
                />
                <path
                  d="M19.0742 44.8796C24.1185 44.8796 28.9562 42.9285 32.5231 39.4557C28.5754 27.7965 24.826 22.2518 15.0942 14.328L8.42163 9.99669C8.24065 9.8793 8.03766 9.79782 7.8243 9.75691C7.61093 9.716 7.39137 9.71646 7.17818 9.75826C6.965 9.80007 6.76237 9.8824 6.58191 10.0005C6.40144 10.1187 6.24668 10.2703 6.12647 10.4468C2.09722 16.3599 0.0546875 21.7146 0.0546875 26.3613C0.0546875 31.2726 2.05853 35.9828 5.62538 39.4557C9.19224 42.9285 14.0299 44.8796 19.0742 44.8796Z"
                  fill="#2A91D7"
                />
              </svg> */}
              <img src={companyLogo} width="39" height="45" />
              <h2 className="text-white text-4xl font-Roboto px-2">Fabrik</h2>
            </Link>
            <div className="flex py-4 px-4 ml-4 mr-4 items-center">
              <Link to="/dashboard" className=" flex items-center ">
                <svg
                  width="22"
                  height="19"
                  viewBox="0 0 22 19"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M9.69893 0.802157C10.0615 0.491232 10.5233 0.320312 11.0009 0.320312C11.4785 0.320312 11.9404 0.491232 12.3029 0.802157L18.6389 6.23216L21.1259 8.22216C21.2285 8.30423 21.3139 8.40571 21.3772 8.52078C21.4406 8.63586 21.4806 8.76229 21.4951 8.89285C21.5096 9.02341 21.4982 9.15554 21.4617 9.28171C21.4251 9.40787 21.364 9.52559 21.2819 9.62816C21.1999 9.73072 21.0984 9.81611 20.9833 9.87946C20.8682 9.9428 20.7418 9.98286 20.6112 9.99735C20.4807 10.0118 20.3485 10.0005 20.2224 9.96388C20.0962 9.92731 19.9785 9.86623 19.8759 9.78416L19.0009 9.08416V17.0032C19.0009 17.5336 18.7902 18.0423 18.4151 18.4174C18.0401 18.7924 17.5314 19.0032 17.0009 19.0032H13.0009V14.0032C13.0009 13.4727 12.7902 12.964 12.4151 12.5889C12.0401 12.2139 11.5314 12.0032 11.0009 12.0032C10.4705 12.0032 9.96179 12.2139 9.58672 12.5889C9.21164 12.964 9.00093 13.4727 9.00093 14.0032V19.0032H5.00093C4.4705 19.0032 3.96179 18.7924 3.58672 18.4174C3.21164 18.0423 3.00093 17.5336 3.00093 17.0032V9.08316L2.12593 9.78316C2.02406 9.87014 1.90576 9.93577 1.77804 9.97615C1.65033 10.0165 1.5158 10.0309 1.38244 10.0182C1.24909 10.0056 1.11962 9.96636 1.00174 9.90276C0.883849 9.83916 0.779942 9.75252 0.696182 9.64799C0.612422 9.54346 0.550517 9.42316 0.514142 9.29424C0.477766 9.16533 0.467661 9.03042 0.484426 8.89752C0.501192 8.76462 0.544486 8.63645 0.611739 8.52061C0.678992 8.40476 0.768833 8.30361 0.87593 8.22316L3.36293 6.23316L9.69893 0.802157Z"
                    fill="white"
                  />
                </svg>

                <h2 className="text-white text-base font-Roboto px-2">
                  Dashboard
                </h2>
              </Link>
            </div>
            <div className="ml-4 mr-4">
              <ProductionListItem showSideBar={showsidebar} />
              <WarehouseListItem showSideBar={showsidebar} />
              <ManagementListItem showSideBar={showsidebar} />
            </div>
          </div>
        )}

        {/* mini profile */}
        {!showsidebar && (
          <div className="min-w-max bg-blue-200 border-r border-blue-200 rounded-r-lg flex flex-col items-center">
            <Link
              to="/dashboard/company-profile"
              className="py-10 px-4 flex items-center"
            >
              {/* <svg
                width="39"
                height="45"
                viewBox="0 0 39 45"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M38.0938 26.3591C38.0938 31.2705 36.0899 35.9807 32.5231 39.4535C28.9562 42.9264 24.1185 44.8774 19.0742 44.8774C14.0299 44.8774 9.19224 42.9264 5.62538 39.4535C2.05853 35.9807 0.0546876 31.2705 0.0546875 26.3591C0.0546875 21.7124 2.09722 16.3578 6.12647 10.4446C6.24668 10.2682 6.40144 10.1165 6.58191 9.99838C6.76237 9.88024 6.965 9.79791 7.17818 9.7561C7.39137 9.7143 7.61093 9.71384 7.8243 9.75475C8.03766 9.79567 8.24065 9.87715 8.42163 9.99453L15.0942 14.3258L21.4719 1.28529C21.5857 1.05263 21.7551 0.849942 21.966 0.694265C22.1769 0.538588 22.4231 0.434465 22.6839 0.390643C22.9446 0.346821 23.2124 0.364581 23.4647 0.442431C23.717 0.52028 23.9464 0.655945 24.1336 0.838028C27.1817 3.80056 30.6621 7.39432 33.3652 11.5853C36.5468 16.5188 38.0936 21.3513 38.0936 26.3589L38.0938 26.3591Z"
                  fill="#00EDDF"
                />
                <path
                  d="M19.0742 44.8796C24.1185 44.8796 28.9562 42.9285 32.5231 39.4557C28.5754 27.7965 24.826 22.2518 15.0942 14.328L8.42163 9.99669C8.24065 9.8793 8.03766 9.79782 7.8243 9.75691C7.61093 9.716 7.39137 9.71646 7.17818 9.75826C6.965 9.80007 6.76237 9.8824 6.58191 10.0005C6.40144 10.1187 6.24668 10.2703 6.12647 10.4468C2.09722 16.3599 0.0546875 21.7146 0.0546875 26.3613C0.0546875 31.2726 2.05853 35.9828 5.62538 39.4557C9.19224 42.9285 14.0299 44.8796 19.0742 44.8796Z"
                  fill="#2A91D7"
                />
              </svg> */}
              <img src={companyLogo} width="39" height="45" />
            </Link>
            <div className="flex py-4 px-4 ">
              <Link to="/dashboard" className=" flex items-center mb-2 ">
                <HiHome size={25} color="#FFFFFF" />
              </Link>
            </div>
            <div className="">
              <ProductionListItem showSideBar={showsidebar} />
              <WarehouseListItem showSideBar={showsidebar} />
              <ManagementListItem showSideBar={showsidebar} />
            </div>
          </div>
        )}

        {/* navbar */}
        <div className="flex-1">
          <div className="flex justify-between h-12 items-center">
            <div>
              <button className="py-6 px-4" onClick={handleShow}>
                <IoReorderThreeOutline size={30} />
              </button>
            </div>
            <div className="flex justify-start items-center pr-2 space-x-3">
              <IoMdNotificationsOutline size={30} />
              <IoSettingsOutline size={30} />
              {/* <Link to="/dashboard/user-profile"> */}
                <CgProfile size={30} className="cursor-pointer"  onClick={() => {
                      showdropdown();
                    }}/>
              {/* </Link> */}
              {showDropdown ? (
            <div className="absolute rounded-lg bg-blue-200 top-12 right-8 ">
              <ul className="py-2 text-normal text-white px-4">
              {DropdownItems.map((items) => (
                <li key={items.id}>
                  {items.Name === "Logout" ? (  
                  <a
                    className="flex py-2 px-4  hover:bg-blue-100 border-b border-white active:text-white cursor-pointer focus:text-white"
                    onClick={() =>{LogoutHandler(); dispatch(setshowDropdown(false));}}
                  >
                    {items.icon}
                    {items.Name}
                  </a>):(  <a
                    className="flex py-2 px-4  hover:bg-blue-100 border-b border-white active:text-white cursor-pointer focus:text-white"
                    onClick={()=>{Navigate(items.Link); dispatch(setshowDropdown(false));}}
                  >
                    {items.icon}
                    {items.Name}
                  </a>)}
                </li>
 ))}
               
              </ul>
            </div>
          ) : null}
              <div></div>
            </div>
          </div>
          <div className="pt-10 px-10" onClick={()=>{ dispatch(setshowDropdown(false));}}>
            <Outlet />
          </div>
        </div>
      </div>
    </>
  );
}
